<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_punctuationMarks') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_category') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSetting_' + parameters.category) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_rule') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSetting_' + parameters.rule) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_showingCorrectAnswers') }}
            span(slot="value") {{ $i18n.t(parameters.showingCorrectAnswers ? 'trainer.trainer_gameFormSettingValue_onAbbreviated' : 'trainer.trainer_gameFormSettingValue_offAbbreviated')  }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
    };
</script>
